/*
	封装数据接口
*/

const URL = {
	findplist: {
		url: '/front/portal/product/selectproductlist',//产品列表展示
		params: {}
	},
	bindChange: {
		url: '/center/tb/bindChange',//修改银行卡号
	},
	removebatchinfo: {//删除抽奖批次信息
		url: '/award/award/batch-info/removebatchinfo',
		params: {}
	},
	getawarduserdetail: {//查询中奖人详情
		url: '/award/award/user/getuserdetail',
		params: {}
	},

	lottery: {
		url: '/award/award/user/lottery3',//用户抽奖接口
		params: {}
	},

	getuserdetail1: {
		url: '/auth/sysUser/user',//获取用户信息
		params: {}
	},
	updateawardlist: {
		url: '/award/create-batch/update',//更新奖品列表页面数据
		params: {}
	},
	deleteaward: {//删除单个奖品类别
		url: '/award/create-batch/delete',
		params: {}
	},
	getawardlist: {
		url: '/award/create-batch/', //奖品列表展示
	},
	updateuserdetail: {
		url: '/award/award/user/updateuserdetail', //post 获奖用户地址发送
		params: {}
	},
	getuserdetail: {
		url: '/award/award/user/getuserdetail', //获取用户手机号地址姓名
		params: {}
	},
	getuserlist: {
		url: '/award/award/user/getuserlist',//GET 活动页语人列表
		params: {}
	},
	getawardList: {
		url: '/award/award/user',//GET 参与活动列表
		params: {}
	},
	savebatchInfo: {
		url: '/award/create-batch/batchinfo',//活动名活动细节描述
		params: {}
	},
	saveBatch: {
		url: '/award/create-batch/save',//POST活动奖品保存
		params: {}
	},
	getProductType: {         // GET 产品类型
		url: '/front/portal/product/selectproductlist',
		params: {}
	},
	getRecommend: {         // GET 热门推荐
		url: '/manager/product/hot ',
		params: {}
	},

	getqueryList: {         // GET 热门推荐
		url: '/award/award/batch-info/query',
		params: {}
	},
	qaList: {//问卷列表
		url: '/activities/qa/list',

		params: {}
	},
	oneQuestionnaire: {//单个问卷内容
		url: '/activities/qa/one',
		params: {}
	},
	getregion:{
		url:'/center/region/getall',
		params: {}
	},
	lusaveBy:{
		url:'/auth/sysUser/luSaveByUser',
		params:{}
	},
	login1:{//登录
		url:'/auth/checkCode1',
		params:{}
	},
	questionnaires: {//某个问卷的所有答题详情
		url: '/activities/qa/users',
		params: {}
	},
	lufax:{
		url:'/center/lufax/login',
		params:{}
	},
	luupdateuse:{
		url:'/center/lufaxorder/updateuser'
	},
	getUserCode: {//获取用户code b端 主页
		url: '/center/wechat/code',
		params: {}
	},
	wechatCode: {//获取用户code url c端授权
		url: '/auth/chat/code',
		params: {}
	},
	getUserInfo: {//用户信息
		url: '/center/wechat/userinfo',
		params: {}
	},
	saveTitle: {//保存或修改问卷名称,描述
		url: '/activities/qa/title',
		params: {}
	},
	saveOption: {//保存新的问题选项
		url: '/activities/qa/option',
		params: {}
	},
	findQaType: {//根据id查询问卷,描述
		url: '/activities/qa/type',
		params: {}
	},
	removeOption: {//根据id删除一个问题和选项
		url: '/activities/qa/type-option',
		params: {}
	},
	changeReleaseFlag: {//根据id修改问卷发布状态
		url: '/activities/qa/status',
		params: {}
	},
	removeQuestionnaire: {//删除一个问卷
		url: '/activities/qa/questionnaire',
		params: {}
	},
	saveQuestionnaire: {//提交问卷
		url: '/activities/qa/save ',
		params: {}
	},
	getCustomerCodeUrl: {//获取用户授权的url
		url: '/activities/card/qaUrl',
		params: {}
	},

	gitawardlist: {
		url: '/award/create-batch/' //创建活动列表
	},

	hotProduct: {
		url: '/front/portal/product/selectproductlist' //热门推荐更多
	},
	productDetails: {
		url: '/front/portal/product/findProductById' //产品详情
	},
	postConsult: {
		url: '/front/front/product-message' //咨询
	},
	ProductType: {
		url: '/front/portal/product/findAllProductType' //产品类型
	},
	ProductTypeList: {
		url: '/front/portal/product/findByProductTypeId' //产品列表
	},
	qixinProdUrl: {
		url: '/front/portal/product/url' //齐欣产品访问链接
	},
	//个人中心
	createOrders: { // 创建订单 post
		url: '/manager/personal/order',
		params: {}
	},
	getOrders: { // 获取订单列表 get
		url: '/manager/personal/order',
		params: {}
	},
	getTips: { // 获取需求列表 get
		url: '/manager/personal/tips',
		params: {}
	},
	addTips: { // 新增需求
		url: '/manager/personal/tips',
		params: {}
	},
	getProductTypeAndProduct: { // 查询产品类型和类型下的产品
		url: '/manager/personal/type-product'
	},
	uploadImg: { // 个人中心 图片上传
		url: '/manager/file',
		params: {}
	},
	uploadmessageImg: {//上传文件
		url: '/file/file/uploadFile'
	},
	removeFile: {//删除文件
		url: '/file/file/remove',
		params: {}
	},
	orderDetails: { // 订单详请
		url: '/manager/personal/detail',
		params: {}
	},
	wx: {//获取微信网页授权地址
		url: '/activities/card/commonAuthUrl',
		params: {}
	},
	getUser: {//获取用户信息
		url: '/auth/sysUser/user',
		param: {}

	},
	noticemessage: {//发送短信
		url: '/center/wechat/sendmessage',
		params: {}
	},
	sendCode: {//获取验证码
		url: '/center/sms/send',
		params: {}
	},
	login: {//登录
		url: '/auth/checkCode',
		params: {}
	},
	getopenid:{
		url:'/center/zhifu/userinfo',
		params: {}
	},
	checkOpenid: {//是否绑定手机
		url: '/auth/bindingInfo?openid=',
		params: {}
	},
	isLink: {//是否外链
		url: 'front/front/accessRecord',
		params: {}
	},
	singleCode: {//买家授权链接
		url: '/activities/card/single',
		params: {}
	},
	business: {//立即展开业务
		url: '/auth/sysUser/saveByUser',
		params: {}
	},
	productConsult: {//咨询保存接口
		url: '/front/front/consult',
		params: {}
	},
	idcardAudit: {//二要素身份认证
		url: '/center/audit/idcardAudit',
		params: {}
	},
	saveUserMain: {//修改用户主表信息
		url: '/auth/sysUser/updatemain',
		params: {}
	},
	updatetime: {//购买会员后更新会员时间
		url: '/t-ufc-viptime/updatetime',
		params: {}
	},
	bannerList: {//广告位设置
		url: '/front/portal/product/ads',
		params: {}
	},
	upImg: {//职业照上传
		url: '/file/file/uploadFile',
		params: {}
	},
	getStaffsCard: {//get获取个人信息\ post编辑个人信息
		url: '/auth/staffs/card',
		params: {}
	},
	getBindingInfo: {//post 获取用户相关绑定认证信息 参数openid
		url: '/auth/bindingInfo',
		params: {}
	},
	getAgentList: {//获取我推荐的经纪人列表
		url: '/front/agents/list',
		params: {}
	},
	getQAList: {//获取咨询列表
		url: '/front/front/qa',
		params: {}
	},
	getSign: {//个人日签
		url: '/front/ufc/getSign',
		params: {}
	},
	getSignType: {//个人日签f分类
		url: '/front/ufc/getother',
		params: {}
	},
	getstaff: {//获取个人信息
		url: '/auth/staffs/id',
		params: {}
	},
	traceSave: {//通过谁的二维码购买的产品
		url: '/auth/trace/save',
		params: {}
	},
	postAmount: {//我的资金
		url: '/front/agent/amount',
		params: {}
	},
	postCash: {//提现
		url: '/front/agent/cash',
		params: {}
	},
	cardBinding: {//银行卡绑定
		url: '/front/agent/binding',
		params: {}
	},
	postOrders: {//订单列表
		url: '/front/agent/orders',
		params: {}
	},
	cashRecord: {//提现记录
		url: '/front/agent/cash',
		params: {}
	},
	myCard: {//我的账户
		url: '/auth/account/card',
		params: {}
	},
	getSwiperInfo: {//轮播图查询
		url: '/ufc/api/article/queryAdvertisingCarousel',
		params: {}
	},
	checkAuthority: {//上传权限验证
		url: '/ufc/judge/isAdministrator',
		params: {}
	},
	getCardByUnionid: {//获取名片Unionid
		url: '/auth/staffs/unionid',
		params: {}
	},
	insertComplaints: {//投诉
		url: '/ufc/api/article/insertComplaints',
		params: {}
	},
	getCard: {//获取名片openid  素材列表
		url: '/ufc/api/agent-card/selectAisAgentCard',
		params: {}
	},
	graphicDetails: {//图文详情get
		// url: '/front/ufc/detail',
		url: '/ufc/getById',
		params: {}
	},
	queryMyMessage: {//获取头像相关接口
		url: '/api/questions/questions/queryMyMessage',
		params: {}
	},
	checkUser: {//验证是否是注册用户
		url: '/auth/bindingInfo1',
		params: {}
	},
	subViewduration: {//访问时长统计
		url: '/ufc/user-act/log/updateViewDuration',
		params: {}
	},
	userActive: {//用户访问统计
		// url: '/api/prizecustomer/user-act/log/save',
		url: '/ufc/user-act/log/save',
		params: {}
	},
	articleShare: {//文章分享 素材列表、销售线索
		// url: '/ufc/api/questionnaires/weixin/ws',
		url: '/ufc/weixin/ws',
		params: {}
	},
	articleShareSuccess: {//分享成功 素材列表、销售线索
		url: '/ufc/api/fordward-record/save',
		params: {}
	},
	articleDetails: {//文章详情
		url: '/ufc/api/article/selectAisArticle',
		params: {}
	},
	getUploadList: {//查看已上传文章列表
		url: '/ufc/api/article/selectOwnUploadArticle',
		params: {}
	},
	getSharedList: {//查看已分享文章列表
		url: '/ufc/api/fordward-record/selectForwardRecord',
		params: {}
	},
	del: {//删除文章
		url: '/ufc/api/article/deleteOriginalAisArticle',
		params: {}
	},
	getUploadDetails: {//更新
		url: '/ufc/api/article/selectArticleVo',
		params: {}
	},
	beforUploade: {//文章上传去重校验
		url: '/ufc/api/article/isUpload',
		params: {}
	},
	uploadArticleByUrl: {//文章上传
		url: '/ufc/api/article/uploadArticle',
		params: {}
	},
	uploadFile: {//图片或视频上传
		url: '/ufc/api/articleWxPic/save',
		params: {}
	},
	uploadOriginalArticle: {//原创文章上传
		url: '/api/prizecustomer/api/article/uploadOriginalArticle',
		params: {}
	},
	updateFile: {//更新
		url: '/api/prizecustomer/api/article/updateArticle',
		params: {}
	},
	searchPageArticle: {//搜索文章
		url: '/ufc/api/article/searchPageArticle',
		params: {}
	},
	getVideoInfo: {//视频内容查询
		url: '/ufc/api/article/queryVideoList',
		params: {}
	},
	getHomeArticle: {//文章查询接口
		url: '/ufc/api/article/queryArticleList',
		params: {}
	},
	getTopArticle: {//置顶文章查询
		url: '/ufc/api/article/queryTopList',
		params: {}
	},
	// 我的团队
	teamData: {//团队数据
		url: '/front/team/data',
		params: {}
	},
	teamPeople: {//团队人员
		url: '/front/team/members',
		params: {}
	},
	teamOrders: {//团队进件
		url: '/front/team/orders',
		params: {}
	},
	teamAchievement: {//团队业绩
		url: '/front/team/achievement',
		params: {}
	},
	getAuthInfo: {//获取android用户 授权信息
		url: '/auth/sysUser/user-info',
		params: {}
	},
	getByPhoneNo: {//根据手机号查询用户信息
		url: '/auth/sysUser/getByPhoneNo',
		params: {}
	},

	getClueList: {//各种活动访问、转发统计列表 销售线索
		url: '/ufc/api/clue/query',
		params: {}
	},
	getClueDetails: {//访问、转发人员列表 销售线索
		url: '/ufc/api/activite-tends/query',
		params: {}
	},
	getUInfo: {//用户信息 销售线索
		url: '/ufc/weixin/tologin/userinfo',
		params: {}
	},
	updateMyInfo: {//更新用户信息表 销售线索
		url: '/ufc/api/wechatPersonmsg/update',
		params: {}
	},
	getCustomerList: {//客户列表 销售线索
		url: '/ufc/prizecustomer/queryMyCustomers',
		params: {}
	},
	addCustomer: {//保存  post 销售线索
		url: '/ufc/api/customer/save',
		params: {}
	},
	getTreeForward: {//转发链条 销售线索
		url: '/ufc/treeForward/view',
		params: {}
	},
	updateCustomer: {//修改接口 post 销售线索
		url: '/ufc/api/customer/update',
		params: {}
	},
	getCustomerInfo: {//查询详情 get 销售线索
		url: '/ufc/api/customer/query',
		params: {}
	},
	queryAisCustomers: {//获取未关联客户列表  销售线索
		url: '/ufc/api/customer/queryAisCustomers',
		params: {}
	},
	deleteCustomer: {//删除  销售线索
		url: '/ufc/api/customer/delete',
		params: {}
	},
	getCustomerHoby: {//用户喜好  销售线索
		url: '/ufc/api/article/queryHighLikeCustomers',
		params: {}
	},
	getArticleList: {//文章列表  销售线索
		url: '/ufc/api/article/queryLikeCustomers',
		params: {}
	},
	getClueCard: {//获取名片  销售线索
		url: '/auth/sysUser/userinfobyunionid',
		params: {}
	},
	getAuthentication: {//鉴权  销售线索
		url: '/ufc/uthentication/server',
		params: {}
	},
	//rrweb----
	getClientStatus: {//获取状态  销售线索
		url: '/ufc/updateClients',
		params: {}
	},
	delClientStatus: {//退出后清空数据  销售线索
		url: '/ufc/delete',
		params: {}
	},
	// 消息
	getMessageList: {//查看消息列表
		url: '/center/cmn/accessTrace',
		params: {}
	},
	getMessageCount: {//查看消息总数
		url: '/center/cmn/unread',
		params: {}
	},
	MsgUpdatestate: {//修改消息状态
		url: '/center/cmn/flag',
		params: {}
	},
	staffcard: {//创建名片
		url: '/front/staffcard/save',
		params: {}
	},
	getStaffcard: {//创建名片查询
		url: '/front/staffcard',
		params: {}
	},
	articlesShared: {//经纪人分享的文章
		url: '/ufc/api/fordward-record/selectForwardRecord',
		params: {}
	},
	productSave: {//提交推荐产品保存
		url: '/front/recommend/save',
		params: {}
	},
	recommendProduct: {//推荐产品查询接口
		url: '/front/recommend/qryByPhoneNo',
		params: {}
		//"phoneNo":"15225303218"
	},
	qryCusTrace: {//我的足迹查询接口
		url: '/auth/trace/qryCusTrace',
		params: {}
		//"agentPhoneNo":"15225303218"
	},
	IDImg: {//身份证正反面图片上传
		url: '/file/file/uploadFileAssignDir',
		params: {}
		//"agentPhoneNo":"15225303218"
	},
	sassSend: {//sass获取验证码
		url: '/center/sms/send2',
		params: {}
	},
	sassLogin: {//sass登录
		url: '/auth/checkCode2',
		params: {}
	},
	sassPaid: {//sass支付列表
		url: '/center/t-payment/list',
		params: {}
	},
	sassPaidDetails: {//sass支付列表 get orderid
		url: '/center/t-payment/detail',
		params: {}
	},
	myCustomer: {//我的客户列表 get
		url: '/front/customer/list',
		params: {}
	},
	CustomerDetail: {//我的客户详情 get
		url: '/front/customer/detail',
		params: {}
	},
	editCustomer: {//编辑客户信息 post
		url: '/front/customer/detail',
		params: {}
	},
	loanList: {//全部订单 贷款列表
		url: '/center/lufaxorder/getList',
		params: {}
	},
	safeList: {//全部订单 保险列表 b端
		url: '/manager/sumorder',
		params: {}
	},
	safeDetails: {//全部订单 保险详情
		url: '/center/eleorder/byid',
		params: {}
	},
	getInvite: {//邀请好友  page:'1',size:'10'
		url: '/front/invite',
		params: {}
	},
	posterImage: {//海报管理
		url: '/front/poster',
		params: {}
	},
	quoteImg: {//车险上传图片
		url: '/file/file/uploadFileAssignDir',
		params: {}
	},
	quotePro: {//车险咨询接口
		url: '/front/front/pre-order',
		params: {}
	},
	judgeWhetherSub: {//判断用户是否关注服务号
		url: '/center/wechat/sub',
		params: {}
	},
	insuranceList: {//全部订单 保险列表 c端
		url: '/front/order/list',
		params: {}
	},
	changeOrderStatus: {// 保险订单修改状态为4-待支付 c端
		url: '/front/order/status',
		params: {}
	},
	dictData: {// 查询字典值
		url: '/manager/api/dictDetail/data',
		params: {}
	},
	findPayImg: {// 查询对应城市支付码
		url: '/center/t-payment/img',
		params: {}
	},
	bindTask: {// 查询对应城市支付码
		url: '/center/tb/bind',
		params: {}
	},
	getTask: {// 查询对应城市支付码
		url: '/center/tb/getTask',
	},
	getTuibaUserInfo: {// 查询推吧用户信息
		url: '/center/tb/getTuibaUserInfo',
	},
	
	
}
export default URL;
